import { RuleMessage } from '../traveldoc/rulemessage';

export class PriorityItem {
  title: string;
  items: Array<RuleMessage>;
  constructor() {
    this.items = new Array<RuleMessage>();
  }
}
